import { render, staticRenderFns } from "./SharedLinkCopyDialogBox.vue?vue&type=template&id=3f615fbd&scoped=true&"
import script from "./SharedLinkCopyDialogBox.vue?vue&type=script&lang=js&"
export * from "./SharedLinkCopyDialogBox.vue?vue&type=script&lang=js&"
import style0 from "./SharedLinkCopyDialogBox.vue?vue&type=style&index=0&id=3f615fbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f615fbd",
  null
  
)

export default component.exports